import React from 'react';
import '../styles/WhatsappButton.css'; // Importamos su propio CSS

const WhatsappButton = () => {
    return (
        <div className="whatsapp-container">
            <a 
                href="https://wa.me/3497401754"  // ⚠️ ¡REEMPLAZA CON EL NÚMERO REAL!
                className="whatsapp-btn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contactar por WhatsApp"
            >
                {/* Icono más grande */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.05 20.16C10.57 20.16 9.12 19.77 7.85 19.01L7.55 18.83L4.43 19.65L5.26 16.61L5.07 16.31C4.26 15.01 3.83 13.49 3.83 11.91C3.83 7.39 7.52 3.7 12.05 3.7C14.24 3.7 16.3 4.56 17.85 6.11C19.4 7.66 20.26 9.72 20.26 11.92C20.26 16.44 16.57 20.16 12.05 20.16ZM16.53 14.86C16.29 14.74 15.09 14.15 14.87 14.07C14.65 13.99 14.49 13.95 14.32 14.19C14.16 14.43 13.69 14.99 13.55 15.15C13.41 15.31 13.26 15.33 13.02 15.21C12.78 15.09 12 14.83 11.08 14.01C10.36 13.37 9.87 12.58 9.63 12.17C9.39 11.76 9.6 11.54 9.72 11.42C9.83 11.31 9.97 11.14 10.09 11C10.21 10.86 10.25 10.76 10.33 10.6C10.41 10.44 10.37 10.3 10.31 10.18C10.25 10.06 9.78 8.9 9.58 8.43C9.39 7.97 9.19 8.03 9.04 8.03C8.9 8.03 8.73 8.02 8.56 8.02C8.4 8.02 8.13 8.08 7.9 8.33C7.67 8.58 7.02 9.19 7.02 10.43C7.02 11.67 7.93 12.87 8.06 13.04C8.19 13.21 9.86 15.79 12.42 16.9C13.03 17.16 13.51 17.32 13.88 17.44C14.53 17.65 15.12 17.62 15.59 17.55C16.12 17.47 17.21 16.89 17.44 16.24C17.67 15.59 17.67 15.04 17.6 14.92C17.53 14.8 17.38 14.74 16.53 14.86Z" />
                </svg>
                
                <span className="whatsapp-tooltip">¡Escribinos a nuestro WhatsApp!</span>
            </a>
        </div>
    );
};

export default WhatsappButton;